<script>
import { faTrash } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'BulkDeleteButton',
  data(){
    return {
      parentIdParam: null
    }
  },
  props: {
    btnText: {
      type: String,
      default: 'Delete'
    },
    toolTipText: {
      type: String,
      default: 'Delete Selected'
    },
    selectedIds: {
      type: Array,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    },
    parentId: {
      type: [Number, String],
      default: null
    }
  },
  mounted() {
    this.parentIdParam = this.$router?.currentRoute?.params?.id
  },
  methods: {
    faTrash() {
      return faTrash
    },
    async confirmAndDelete() {
      try {
        const result = await this.showConfirmationDialog()

        if (!result.isConfirmed) return

        const response = await this.onDelete({
          selectedIds: this.selectedIds.map(Number),
          parentId: parseInt(this.parentId || this.parentIdParam)
        })

        this.$emit('bulkDeleteComplete', response)
      } catch (error) {
        let message = error?.response?.data?.data?.error?.message
          || error?.message
          || 'An error occurred during deletion.'

        this.$swal.fire({
          title: 'Deletion Error!',
          text: message,
          icon: 'error',
          confirmButtonText: 'OK'
        })
      }
    },
    showConfirmationDialog() {
      return this.$swal.fire({
        title: `Are you sure?`,
        text:  'This operation cannot be undone.',
        icon: 'warning',
        html: '',
        toast: false,
        confirmButtonText: 'Yes',
        allowOutsideClick: false,
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      })
    }
  }
}
</script>

<template>
  <div class="remove-items">
    <b-tooltip
      custom-class="remove-items-tooltip"
      target="remove-items-action">
      {{toolTipText}}
    </b-tooltip>
    <b-button id="remove-items-action"
              :disabled="!selectedIds.length"
              @click="confirmAndDelete"
              class="button btn-danger rounded-0"
    >
      {{ btnText }} <font-awesome-icon
      v-if="selectedIds.length"
      :icon="faTrash()"
      class="ml-2"
    ></font-awesome-icon>
    </b-button>
  </div>
</template>

<style scoped lang="scss">
.remove-items {
  display: inline;
}

.remove-items-tooltip {
  top: 5px !important;
}

.button {
  cursor: pointer;
}

.btn-danger:not(:disabled) {
  background-color: #FF6347;
  border: solid 1px #FF6347;
  color: #fff;
}
</style>
